<template>
<div>
<v-container fluid>
<v-btn class="primary" @click="ExportExcel()">Download to excel</v-btn>
<v-card-title>
     <h2 class="primary--text"> Past Orders </h2>
      <v-spacer> </v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field> 
</v-card-title>
    <v-data-table
      id="table"
      :headers="headers"
      :items="bookingData"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, -1]
      }"
      :search="search"
      class="elevation-1"
    >
    </v-data-table>
    <br/>
    <v-btn v-on:click="loadMore" :disabled="isAdmin ? adminPageEnd : driverPageEnd" class="primary">Load More</v-btn>
</v-container>
  </div>
</template>
<script>
import 'table2excel';

export default {
  name: 'Disposals',
  props: {
    bookings: Array
  },
  
  data() {
    return {
      headers: [
        {
          text: 'Id',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        { text: 'Order Number', value: 'orderNumber' },
        { text: 'Customer', value: 'customer' },
        { text: 'Company', value: 'company' },
        { text: 'Date', value: 'date' },
        { text: 'Address', sortable: false, value: 'address' },
        { text: 'Waste', sortable: false, value: 'wasteName' },
        { text: 'Vehicle', sortable: false, value: 'vehicleName' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Driver', sortable: false, value: 'driver' }
      ],
      bookingData: [],
      search: '',
    }
  },

  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    adminPageEnd(){
      return this.$store.getters['admin/getAdminDisposalPageEnd'];
    },
    adminQuery(){
      return this.$store.getters['admin/getAdminDisposalQuery'];
    },
    driverPageEnd(){
      return this.$store.getters['admin/getDriverDisposalPageEnd'];
    },
    driverQuery(){
      let driverQuery = {
        driverId: this.$store.getters['auth/getUser'].id,
        query: this.$store.getters['admin/getDriverDisposalQuery']
      }
      return driverQuery;
    }
  },
  methods:{
    ExportExcel() {
      const Table2Excel = window.Table2Excel;
      const table2excel = new Table2Excel();
      table2excel.export(document.querySelectorAll("table"));
    },
    loadMore() {
      if(this.isAdmin){
        this.$store.dispatch('admin/fetchAdminDisposals', this.adminQuery);
      }
      else{
        this.$store.dispatch('admin/fetchDriverDisposals', this.driverQuery);
      }
    }
  },
  mounted() {
    this.bookings.forEach((booking) => {
      this.bookingData.push({
        id: booking.orderNumber.id,
        orderNumber: booking.orderNumber.number,
        customer: booking.customer.firstName + " " + booking.customer.lastName,
        company: booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName + " " + booking.customer.lastName,
        date: booking.preferredDate,
        address: booking.capturedAddress,
        wasteName: booking.waste.name,
        vehicleName: booking.vehicle.name, 
        status: booking.status.status,
        driver: booking.driver.name
      });
    })
  }
}
</script>

<style scoped>

</style>
